import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { PaymentSettlementModel } from "src/app/model/PaymentSettlementModel";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
import { ModalController } from "@ionic/angular";
import { log } from "console";

@Component({
  selector: "app-secure-change-eligibility",
  templateUrl: "./change-eligibility.component.html",
  styleUrls: ["./change-eligibility.component.scss"],
})
export class ChangeEligibilityComponent implements OnInit {
  lotteryList: PaymentSettlementModel[] = [];
  loaded: boolean = false;
  loaded1: boolean = false;
  isLoading: boolean = false;
  selectedFile: File;
  selectedLotteryCode: string | null = null;
  page: Page<PaymentSettlementModel>;
  dataSource: MatTableDataSource<PaymentSettlementModel> =
    new MatTableDataSource();
  selectedElement: PaymentSettlementModel[] = [];

  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  count: string;
  appealEligibility: string;
  approveRemark: string;
  filterForm: FormGroup = new FormGroup({});
  form: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "checkbox",
    "id",
    "applicationNo",
    "applicantName",
    "schemaCode",
    "applicationDrawStatus",
    "eligibilityStatus",
  ];
  pageSizeOptions: number[] = [100, 200, 400];
  totalRows = 0;
  pageSize = 100;
  currentPage = 0;
  orderDocumentFile: string | ArrayBuffer;
  orderDocumentFileFOrView: string | ArrayBuffer;
  orderDocument: string;
  orderFile: string;
  isSubmitDisabled: boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController,
    private route: ActivatedRoute,

    private paymentSettlementService: PaymentSettlementService
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });
    this.form = new FormGroup({
      file2: new FormControl(null, Validators.required),
      appealEligibility: new FormControl(true),
      approveRemark: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(2000),
      ]),
    });
    this.loadData();
  }

  loadData() {
    this.paymentSettlementService
      .getChangeEligibilityList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.loaded = true;
          console.log("Page ", page);
          this.page = page;
          if (page.content[0] !== null) {
            this.dataSource = new MatTableDataSource(page.content);
          } else {
            this.dataSource = new MatTableDataSource<PaymentSettlementModel>(
              []
            );
          }

          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
        },
        (error) => {
          console.log(error);
          this.isSearchDisabled = false;
        }
      );
  }
  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.dataSource = null;
      this.pageSize = 0;
      this.currentPage = 0;
      this.filterForm.value.filterText;

      this.onLoad();
    } else {
      this._snackBar.open("Application Number is Required ", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }
  onLoad() {
    this.loaded = false;
    this.paymentSettlementService

      .getChangeEligibilityFilterList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.page = page;

          if (page.content && page.content.length !== 0) {
            this.dataSource = new MatTableDataSource(page.content);
          } else {
            this._snackBar.open("Application Number Not Found ", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3 * 1000,
            });
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
          this.loaded = false;
        },
        (error) => {
          console.log(error);
          this.loaded = false;
          this.isSearchDisabled = false;
        }
      );
    this.loaded = true;
  }
  handleKeyPress(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }
  onFileSelect(event) {
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.orderDocumentFile = reader.result;
          this.orderDocumentFileFOrView = this.orderDocumentFile;
          const fileNameParts = this.selectedFile.name.split(".");
          this.orderFile = this.selectedFile.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.orderDocument = fileNameWithoutExtension;
        };
      } else {
        this.selectedFile = null;
        this.orderDocumentFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.orderDocumentFile = null;

      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }
  openPreviewOtherDocumentFile() {
    this.PreviewOtherDocumentfile(this.orderDocumentFileFOrView);
  }

  async PreviewOtherDocumentfile(base64) {
    appealdocfile: String;
    this.isLoading = true;
    this.isLoading = false;
    const base64Data = base64.split(",")[1];
    const modal = await this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: base64Data,
        documentName: "Order Letter",
        fileName:
          "ACKNOWLEDGEMENT_" +
          "this.applicationNo" +
          "_" +
          new Date().getTime() +
          ".pdf",
      },
    });
    modal.present();
  }
  resetFilter() {
    // window.location.reload();
    this.selectedElement = [];
    this.filterForm.controls["filterText"].setValue(null);
    // this.form.controls["appealEligibility"].setValue(null);
    this.form.controls["approveRemark"].setValue(null);
    this.selectedFile = null;
    this.count = null;

    this.page = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
    this.loadData();
  }

  onCheckboxCheck(e: any) {
    if (e.target) {
    }
  }
  pageChanged(event: PageEvent) {
    console.log({ event });
    console.log(event.pageSize);
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
  validateOrderDocFile() {
    return typeof this.orderDocumentFile === "string" ? true : false;
  }
  onCheckboxChange(row: PaymentSettlementModel) {
    if (row.isSelected) {
      this.selectedElement.push(row);
      // this.count = this.selectedElement.length.toString();

      console.log("this.selectedElement", this.selectedElement);
    } else {
      const index = this.selectedElement.indexOf(row);
      if (index !== -1) {
        this.selectedElement.splice(index, 1);
      }
    }
    this.count = this.selectedElement.length.toString();
  }
  isRowSelected(row: PaymentSettlementModel): boolean {
    return this.selectedElement.includes(row);
  }

  onAppealSubmit(status: any) {
    this.approveRemark = this.form.value.approveRemark;
    // if (!this.form.value.appealEligibility) {
    //   return this._snackBar.open("Please Select  Check Box", "Close", {
    //     horizontalPosition: "right",
    //     verticalPosition: "top",
    //     panelClass: "warning-toast",
    //     duration: 10 * 1000,
    //   });
    // }

    if (this.selectedElement.length == 0) {
      return this._snackBar.open(
        "Please select at least one Applicant Detials",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 10 * 1000,
        }
      );
    }
    if (!this.validateOrderDocFile()) {
      return this._snackBar.open("Order Document File Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 10 * 1000,
      });
    }
    if (!this.form.value.approveRemark) {
      return this._snackBar.open("Please Enter Remark", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 10 * 1000,
      });
    }

    this.isLoading = true;
    let applicationNumbers = this.selectedElement
      .map((obj) => obj.applicationNo)
      .join(", ");
    console.log("applicationNumbers", applicationNumbers);

    if (
      confirm("Do you want to InEligible Application no -" + applicationNumbers)
    ) {
      this.paymentSettlementService
        .saveEligibility({
          status: status,
          approveRemark: this.approveRemark,
          orderFile: this.orderFile,
          appealEligibility: this.form.value.appealEligibility,
          orderDocumentFile: this.orderDocumentFile,
          selectedElements: this.selectedElement,
        })
        .subscribe((data) => {
          this.isLoading = false;
          this.selectedFile = null;
          this._snackBar.open("Save SuccessFully", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 10 * 1000,
          });
          this.selectedFile = null;
          this.dataSource = new MatTableDataSource<PaymentSettlementModel>([]);
          this.loadData();
          // this.isLoading = true;
        });

      this.selectedElement = [];
      this.filterForm.controls["filterText"].setValue(null);
      // this.form.controls["appealEligibility"].setValue(null);
      this.form.controls["approveRemark"].setValue(null);
      this.count = null;
      this.selectedFile = null;
      this.loadData();
    }
  }
}
